import React, { useState } from 'react';
import { 
    FaPhoneAlt, 
    FaRegEnvelope, 
    FaRegClock,
    FaMapMarkerAlt,
    FaUserTie,       // Новая иконка для менеджера
    FaTelegramPlane  // Новая иконка для Telegram
} from 'react-icons/fa';

// Импорт файла стилей из корня src/
import '../Contacts.css'; 

const locationsData = [
    {
        id: 'tashkent-premium',
        tabName: 'Отдель продаж',
        title: 'BMW MOTORRAD Showroom',
        address: 'г. Ташкент, Мирабадский район, ул. Авлиё Ота, 128',
        phone: '+998 55 501 88 77',
        phoneRaw: '+998555018877',
        managerPhone: '+998 90 768 78 48',     
        managerPhoneRaw: '+998907687848',        
        telegramLink: 'https://t.me/bmwmotorrad_uz',  
        email: 'info@pa.uz',
        schedule: '10:00-19:00',
        // 🔥 ИСПРАВЛЕНО: Ссылка преобразована в формат виджета (map-widget/v1) для корректного отображения внутри iframe
        mapUrl: "https://yandex.ru/map-widget/v1/?oid=108917662981&ll=69.281143%2C41.288914&z=17"
    },
    {
        id: 'tashkent-service',
        tabName: 'BMW MOTORRAD Service Center',
        title: 'BMW MOTORRAD Service Center',
        address: 'г. Ташкент, Бектемирский район, ул. Туёна, 10',
        phone: '+998 55 501 88 77',
        phoneRaw: '+998555018877',
        managerPhone: '+998 90 768 78 48',     
        managerPhoneRaw: '+998907687848',        
        telegramLink: 'https://t.me/bmwmotorrad_uz',   
        email: 'info@pa.uz',
        schedule: '9:00-18:00',
        // 🔥 ИСПРАВЛЕНО: Убрано дублирование склеенных ссылок и переведено в формат виджета
        mapUrl: "https://yandex.ru/map-widget/v1/?oid=173208040187&ll=69.337550%2C41.242324&z=16"
    }
];

const Contacts = () => {
    const [activeLocation, setActiveLocation] = useState(locationsData[0]);

    return (
        <div className="contacts-page-wrapper">
            <div className="contacts-container">
                <h1 className="contacts-title">Контакты</h1>
                <p className="contacts-subtitle">
                    «Premium Auto»
                    Эксклюзивный импортер BMW Motorrad в Узбекистане. 
                    Официальные дилерские центры и сервисные зоны.
                </p>

                {/* Переключатель локаций */}
                {locationsData.length > 1 && (
                    <div className="location-tabs">
                        {locationsData.map((loc) => (
                            <button
                                key={loc.id}
                                className={`tab-btn ${activeLocation.id === loc.id ? 'active' : ''}`}
                                onClick={() => setActiveLocation(loc)}
                            >
                                {loc.tabName}
                            </button>
                        ))}
                    </div>
                )}

                {/* Контент выбранной локации */}
                <div className="contacts-grid">
                    
                    {/* Левая панель информации без соц. сетей */}
                    <div className="info-block-modern">
                        <h2 className="location-main-title">{activeLocation.title}</h2>
                        
                        <div className="info-row-item">
                            <span className="info-item-icon"><FaPhoneAlt /></span>
                            <span className="info-item-text">
                                <p>
                                Шоурум: <a href={`tel:${activeLocation.phoneRaw}`}>{activeLocation.phone}</a>
                                </p>
                            </span>
                        </div>

                        <div className="info-row-item">
                            <span className="info-item-icon"><FaUserTie /></span>
                            <span className="info-item-text">
                                Менеджер: <a href={`tel:${activeLocation.managerPhoneRaw}`}>{activeLocation.managerPhone}</a>
                            </span>
                        </div>

                        <div className="info-row-item">
                            <span className="info-item-icon"><FaTelegramPlane /></span>
                            <span className="info-item-text">
                                Написать Менеджеру: <a href={activeLocation.telegramLink} target="_blank" rel="noopener noreferrer">
                                      Telegram
                                </a>
                            </span>
                        </div>

                        <div className="info-row-item">
                            <span className="info-item-icon"><FaMapMarkerAlt /></span>
                            <span className="info-item-text">{activeLocation.address}</span>
                        </div>

                        <div className="info-row-item">
                            <span className="info-item-icon"><FaRegEnvelope /></span>
                            <span className="info-item-text">
                                <a href={`mailto:${activeLocation.email}`}>{activeLocation.email}</a>
                            </span>
                        </div>

                        <div className="info-row-item">
                            <span className="info-item-icon"><FaRegClock /></span>
                            <span className="info-item-text">{activeLocation.schedule}</span>
                        </div>
                    </div>

                    {/* Правая часть: Интерактивная карта */}
                    <div className="map-container">
                        <iframe
                            title={activeLocation.tabName}
                            src={activeLocation.mapUrl}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allowFullScreen={true}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            style={{ border: 0 }}
                        ></iframe>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Contacts;